import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import CalendarPicker from 'rc-calendar';
import Dropdown from '../Dropdown';
import RightMenu from "../RightMenu";
import RightIconMenu from "../RightIconMenu";
import axios from "axios";

export default class View_type_7 extends Component {

    constructor(props) {
        super(props);

        let data = { title: '', multimedia: [], prev_dropdown: [], ...props.data };
        this.state = {
            data: data,
            prevDropdown: data.prev_dropdown,
            rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
            search: data.search,
            search: '',
            middleUrl: props.middleUrl,
            // searchData: 'searchData',
        }
        //console.log("View_type_7: ", this.state);
        //console.log('current_Edition:', this.state.data.prev_dropdown.current);
    }

    // submitHandler = (e) =>{
    // 	e.preventDefault();
    // 	let searchData = document.getElementById('searchData');

    // 	axios({
    // 		method: 'post',
    // 		url: this.state.middleUrl,
    // 		data: `search=${searchData.value}`,
    // 	})
    // 	.then(respond => {
    // 		this.setState({data: respond.data });
    // 	});
    // }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('search');
        const searchData = document.getElementById('searchData')

        if (searchParam) {
            searchData.value = searchParam
            this.submitHandler(null, searchParam);
        }
    }

    submitHandler(e, searchData) {
        if (e) {
            e.preventDefault();
            searchData = document.getElementById('searchData').value;
        }

        const params = new URLSearchParams();
        params.append('search', searchData);

        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('search', searchData);
        window.history.pushState({}, '', currentUrl)

        axios.post(this.state.middleUrl, params)
            .then(respond => {
                this.setState({ data: respond.data });
            })
            .catch(error => {
                console.error("There was an error!", error);
            });
    }

    render() {
        var var1 = this.state.data.title ? this.state.data.title : "";
        var search = this.state.data.search ? this.state.data.search : [];
        let searchbar = null;
        let content = null;

        if (search.input_main_active == true) {
            searchbar = (
                <div
                    className="vt7 left col-xs-12 col-sm-12 col-md-12 col-lg-9 search-container">
                    <form action={search.action_url} method="POST" onSubmit={e => { this.submitHandler(e) }} >
                        <input aria-label="search" type="search" placeholder={search.input_main_placeholder} ref="search" name="search" id="searchData" />
                        <input aria-label="submit" type="submit" placeholder={search.input_main_placeholder} value=""
                            style={{
                                backgroundImage: ("/static/media/search/search-icon.png")
                            }}
                        />
                    </form>
                </div>
            )

        }
        else {
            searchbar = (
                <div
                    className="vt7 left col-xs-12 col-sm-12 col-md-12 col-lg-9 search-container">
                </div>
            )
        }
        if (this.state.data.prev_dropdown && this.state.data.prev_dropdown.current) {
            content = (
                <div>

                    <div className="vt7 left col-xs-12 col-sm-12 col-md-12 col-lg-9">
                        <div className="row">
                            <p className="vt7 artists-pageTitle col-xs-10 col-sm-10 col-md-10 col-lg-10">{this.state.data.prev_dropdown.current}</p>
                            <div className="vt7 artists-pageTitle col-xs-10 col-sm-10 col-md-10 col-lg-10" dangerouslySetInnerHTML={{ __html: this.state.data.title }}></div>

                            {/* <div className="vt7 col-xs-2 col-sm-2 col-md-2 col-lg-2">{this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null}</div> */}

                        </div>
                        <div className="vt7 top_elements">
                            <ul className="vt7 filters">

                                {this.state.data.sort.map((object, i) => <li className="vt4 calendar-sortunit" key={i}>{object.link == '' ? object.name : <Link className="calendar-sortitem" to={object.link}>{object.name}</Link>}</li>)}

                            </ul>
                        </div>

                        {

                            this.state.data.multimedia.map(function (object, i) {
                                return (
                                    <div className="vt7 col-md-12 multimedia_items" key={i}>
                                        <Link to={"/" + object.url}>
                                            <div className="vt7 row">
                                                <div className="vt7 col-xs-2 col-sm-2 col-md-2 col-lg-2 vt7__date-title">

                                                    <div className="vt7 calendarMzName">
                                                        <div className="vt7 multimedia_item_date">{object.date} </div>
                                                    </div>


                                                </div>
                                                <div className="vt7 col-xs-2 col-sm-3 col-md-3 col-lg-3  vt7__desc-title">
                                                    <Link to={"/" + object.url} aria-label="hyperlink"><div className="vt7 multimedia_item_title"><b>{object.title} </b></div></Link>
                                                    <div>{/* tutaj powinien być obiekt z osobami ktore brały udział w danym koncercie */}</div>

                                                </div>

                                                <div className="vt7 col-xs-7 col-sm-7 col-md-7 col-lg-7  vt7__item-title">

                                                    {object.thumbs.map(function (object1, i) {

                                                        return (<div
                                                            className="vt7 multimedia_thumbs"
                                                            key={object1.id}
                                                            style={{
                                                                backgroundImage: `url(${object1.img})`
                                                            }}>
                                                        </div>);

                                                    })}

                                                </div>

                                            </div>
                                        </Link>
                                    </div>

                                );
                            })
                        }

                    </div>
                    <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                        {this.state.data.right_menu && this.state.data.right_menu_option && (
                            <div className="vt2 RightMenu">
                                <Dropdown giveMeClassName={`${this.state.prevDropdown && this.state.prevDropdown.dates && this.state.prevDropdown.dates.length > 5 ? 'festiwal--dropdown' : 'normal'}`} data={this.state.prevDropdown} />
                                <RightMenu data={this.state.data.right_menu} />

                            </div>
                        )}
                        {this.state.rightIconMenu &&
                            <RightIconMenu data={this.state.rightIconMenu} />
                        }
                    </div>
                </div>

            )
        }
        else {
            content = (
                <div className="vt7 left col-xs-12 col-sm-12 col-md-12 col-lg-12">

                    <div className="row">
                        <div className="vt7 artists-pageTitle col-xs-10 col-sm-10 col-md-10 col-lg-10" dangerouslySetInnerHTML={{ __html: this.state.data.title }}></div>
                        <div className="vt7 artists-pageDescription col-xs-10 col-sm-10 col-md-10 col-lg-10" dangerouslySetInnerHTML={{ __html: this.state.data.description }}></div>
                        {/* <div className="vt7 col-xs-2 col-sm-2 col-md-2 col-lg-2">{this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null}</div> */}
                    </div>
                    <div className="vt7 top_elements">
                        <ul className="vt7 filters">

                            {this.state.data.sort.map((object, i) => <li className="vt4 calendar-sortunit" key={i}>{object.link == '' ? object.name : <Link className="calendar-sortitem" to={object.link}>{object.name}</Link>}</li>)}

                        </ul>
                    </div>

                    {
                        this.state.data.multimedia.map(function (object, i) {

                            return (
                                <div className="vt7 col-md-12 multimedia_items" key={i}>
                                    <Link to={"/" + object.url}>
                                        <div className="vt7 row">
                                            <div className="vt7 col-xs-2 col-sm-2 col-md-2 col-lg-2 vt7__date-title">
                                                <Link to={"/" + object.url} aria-label="multimedia">
                                                    <div className="vt7 calendarMzName">
                                                        <div className="vt7 multimedia_item_date">{object.date} </div>
                                                    </div>
                                                </Link>

                                            </div>
                                            <div className="vt7 col-xs-2 col-sm-3 col-md-3 col-lg-3  vt7__desc-title">
                                                <Link to={"/" + object.url} aria-label="hyperlink"><div className="vt7 multimedia_item_title"><b>{object.title} </b></div></Link>
                                                <div>{/* tutaj powinien być obiekt z osobami ktore brały udział w danym koncercie */}</div>

                                            </div>

                                            <div className="vt7 col-xs-7 col-sm-7 col-md-7 col-lg-7  vt7__item-title">

                                                {object.thumbs.map(function (object1, i) {

                                                    return (<div
                                                        className="vt7 multimedia_thumbs"
                                                        key={object1.id}
                                                        style={{
                                                            backgroundImage: `url(${object1.img})`
                                                        }}>
                                                    </div>);

                                                })}

                                            </div>

                                        </div>
                                    </Link>
                                </div>
                            );
                        })
                    }

                </div>
            )
        }
        return (
            <div>
                {searchbar}
                {content}
            </div>

        );

    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_7/index.js